import { Box, Container, Divider, Paper, Skeleton } from '@mui/material';

export const StaticPageSkeleton = () => {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 5, md: 8 } }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 6 },
          borderRadius: 4,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Skeleton variant="text" sx={{ fontSize: '3rem', width: '50%', mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: '0.875rem', width: '30%', mb: 3 }} />
        <Divider sx={{ mb: { xs: 3, md: 5 } }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Skeleton
            variant="rectangular"
            height={24}
            sx={{ width: '40%', borderRadius: 1, mb: 1, mt: 2 }}
          />
          <Skeleton variant="rectangular" height={20} sx={{ width: '100%', borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={20} sx={{ width: '100%', borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={20} sx={{ width: '85%', borderRadius: 1 }} />
          <Skeleton
            variant="rectangular"
            height={24}
            sx={{ width: '30%', borderRadius: 1, mb: 1, mt: 3 }}
          />
          <Skeleton variant="rectangular" height={20} sx={{ width: '100%', borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={20} sx={{ width: '92%', borderRadius: 1 }} />
        </Box>
      </Paper>
    </Container>
  );
};
